// The projects live in the stay platform (tenant drfah) and load from its API
// at bootstrap (src/index.js) — see src/api/projectsApi.js for the mapping.
//
// These arrays are filled IN PLACE before first render, so every component
// keeps selecting Projects / Projects_ar at render time exactly as it always
// did. The hardcoded per-project modules that used to live beside this file
// (and bundled ~160MB of asset imports) were deleted once the platform became
// the source of truth, and the original image files followed: they are staged
// on the server for `stay import-drfah` (/stay/drfah-import-assets) and live
// in git history. The platform's media rows are the canonical copies.
export const Projects = [];
export const Projects_ar = [];
